/**
 * The axes of `WebTheme` that do not vary between light and dark.
 *
 * Kept in one place so the two themes cannot drift apart on anything except
 * `colors`, which is the only axis a mode is allowed to change.
 */

import { typography } from "../typography";
import { elevation } from "../shadows";
import { space, radius } from "../../current/layout";
import { size } from "../../current/sizing";
import { stroke } from "../../current/borders";
import { zIndex } from "../zIndex";
import { opacity } from "../../current/interaction";
import { duration, delay, easing, spring, stagger } from "../motion";
import type { WebTheme } from "./theme";

export const themeInvariants: Omit<WebTheme, "mode" | "colors"> = {
  typography,
  elevation,
  space,
  size,
  radius,
  zIndex,
  stroke,
  opacity,
  motion: { duration, delay, easing, spring, stagger },
};
